import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/store-health-dashboard",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const storeHealthGenerate = require("./StoreHealthGenerate").default;
          cb(null, storeHealthGenerate);
        },
        "StoreManagement"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/StoreHealthDashboard/GenerateReport/index.js